export default {
};



// WEBPACK FOOTER //
// ./src/components/not-found/NotFound.js